/**
 * My API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface VariableSettingUpdateDto { 
    nickname?: string;
    unit?: string;
    show?: boolean;
    variable_id?: string;
    scaling_factor?: number;
}

